import { NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { FinanceCostPageService } from '../finance-cost.page.service';
import { FinanceCostTrimesterViewPart } from './trimester/finance-cost-trimester-view.part';


@Component({
	selector: 'finance-cost-views-part',
	standalone: true,
	imports: [
		FinanceCostTrimesterViewPart,
		DroplistWidget,
		NgSwitch,
		NgSwitchCase
	],
	templateUrl: './finance-cost-views.part.html',
})
export class FinanceCostViewsPart implements OnInit {

	public service = inject(FinanceCostPageService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}
